/** @jsxImportSource @emotion/react */
"use client";

import { css, type Interpolation } from "@emotion/react";

import {
  constantSemanticColors,
  radius,
  spacing,
} from "../../../../../../global/emotion";
import { Slider } from "../../../../../media/components/primitives/Slider/Slider.emotion";
import type { HallowElementProps } from "../../../../../types/hallowElementProps.types";
import { Text } from "../../../_core/Text/Text.emotion";

const progressBarContainerStyle: Interpolation = css({
  position: "absolute",
  top: spacing.s,
  right: spacing.s,
  borderRadius: radius.full,
  backgroundColor: constantSemanticColors.fixedDarkenMed,
  backdropFilter: "blur(20px)",
  padding: spacing.s,
  height: "24px",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: spacing.s,
});

const labelTextStyle: Interpolation = css({
  color: constantSemanticColors.onColorHighest,
});

export interface ChallengeProgressBarProps extends HallowElementProps<"div"> {
  progress: number;
  label?: string;
  css?: Interpolation;
  sliderCSS?: Interpolation;
}

export const ChallengeProgressBar = ({
  progress,
  css,
  label,
  sliderCSS,
  ...props
}: ChallengeProgressBarProps) => {
  return (
    <div css={[progressBarContainerStyle, css]} {...props}>
      {label && (
        <Text type="detail" size="xl" css={labelTextStyle}>
          {label}
        </Text>
      )}
      <Slider value={progress * 100} onColor={true} css={sliderCSS} />
    </div>
  );
};
